import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import $ from "jquery";
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';
import Loading from '../../loading';
import { Dropdown, Input } from 'semantic-ui-react';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class RequestInItems extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'xl',
    maxWidth1: 'sm',
    requestitems: []
  };

  handleClose = () => {
    this.setState({ addDialog: false })
  }

  viewData() {
    let context = this;
    let mid = this.props.mid;
    this.setState({ load: true, message: 'Getting Request Items' })
    let branch = this.props.selectedBranch;
    $.ajax({
      type: 'POST', data: { 'mid': mid },
      url:Server() + 'stocktransferrequest/getrequestinitems.php',
      success: function(data) {
        console.log(data);
        try {
          data = JSON.parse(data);
          console.log(data);
          context.setState({ requestitems: data, open: true, load: false })
        } catch (e) { context.setState({ load: false }) }
      },
      error: function(err) {
        context.setState({ load: false })
      }
    })
  }

  handleClose = () => { this.setState({ open: false, opencustomedialog: false }) }

  onChnageQty = (type) => (f, { value }) => {
    let stocks = this.state.stocks;
    try {
      stocks = Number(stocks);
      value = Number(value);
    } catch (e) {
    }
    if (stocks >= value) { this.setState({ qty: value }) }
    else { alert('Custom Stock is more then request stock'); }
  }

  customQty() {
    let context = this;
    let orderId = context.state.orderId;
    let qty = context.state.qty;
    let stocks = context.state.stocks;
    let partno = context.state.partno;
    let brand = context.state.brand;
    let branch = context.state.branch;
    let mid = context.state.mid;
    let mrp = context.state.mrp;
    let data = (ReadCookie("branch"));
    let frombranchId;
    for (var i = 0; i < data.length; i++) {
      frombranchId = data[i].branch_id;
    }
    $.ajax({
      type: 'POST',
      data: { 'id': orderId, 'qty': qty, 'requeststocks': stocks, 'partno': partno,
              'brand': brand, 'branch': branch, 'mid': mid, 'frombranchId': frombranchId, mrp },
      url:Server() + 'stocktransferrequest/changecustomstatus.php',
      success: function(data) {
        if (data == 1) {
          context.setState({ qty: '', opencustomedialog: false })
          context.viewData();
        }
        else {
          alert('Try Again!!!')
        }
      },
      error: function(err) {
        context.setState({ load: false })
      }
    })
  }

  status = (id, qty, partno, brand, branch, mid, mrp) => (f, { value }) => {
    if (!this.props.menuPermission.edit) {
      alert('You Are Not Edit this Status!!!');
      return;
    }
    let context = this;
    if (value == 'Custom') {
      this.setState({ opencustomedialog: true, stocks: qty, orderId: id, partno, brand, branch, mid, mrp });
      return;
    }
    let data = (ReadCookie("branch"));
    let frombranchId;
    for (var i = 0; i < data.length; i++) {
      frombranchId = data[i].branch_id;
    }
    $.ajax({
      type: 'POST',
      data: { 'id': id, 'status': value, 'qty': qty, 'partno': partno, 'brand': brand, 'branch': branch, 'frombranchId': frombranchId },
      url:Server() + 'stocktransferrequest/changestatus.php',
      success: function(data) {
        if (data == 1) {
          let data1 = context.state.requestitems;
          data1.map((x) => {
            if (x.detailid == id) { x.status = value; }
          })
          context.setState({ requestitems: data1 })
        }
        else {
          console.log(data);
          alert('Try again');
        }
      },
      error: function(err) {
        context.setState({ load: false })
      }
    })
  }


  downloadpdf() {
    let context = this;
    let mid = this.props.mid;
    let open = Server() + "pdf/stocktransferpdfcreation/index.php?id="+mid;
    window.open(open);
  }

  convertIntoNumber(value) {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  render() {
    let i = 0;
    let menu = [
      { key: 'Closed', text: 'Closed', value: 'Closed' },
      { key: 'Custom', text: 'Custom', value: 'Custom' },
      { key: 'Waiting', text: 'Waiting', value: 'Waiting' }
    ];
    return (
      <div style={{paddingTop: '2%', paddingBottom: '2%'}}>
        <Loading load={this.state.load} message={this.state.message} />
        <div id='pointer' onClick={this.viewData.bind(this)}>View</div>
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.open}
            onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Request IN Items</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <table width='100%' id='table'>
                  <tr>
                    <th><center>Sino</center></th>
                    <th><center>Id</center></th>
                    <th><center>Spare</center></th>
                    <th><center>Brand</center></th>
                    <th><center>Qty</center></th>
                    <th style={{display: this.props.display}}><center>Status</center></th>
                    <th style={{display: this.props.display1}}><center>Status</center></th>
                  </tr>
                  { this.state.requestitems.map((c) => {
                      let adjstock = this.convertIntoNumber(c.adjstock);
                      i++;
                      if (c.status == 'Closed') {
                        return (
                          <tr>
                            <th><center>{i}</center></th>
                            <th><center>{c.detailid}</center></th>
                            <th><center>{c.partno+'->'+c.spare_name}</center></th>
                            <th><center>{c.brand_id}</center></th>
                            <th><center>{c.stock}</center></th>
                            <th style={{display: this.props.display}}><center>{c.status}</center></th>
                            <th style={{display: this.props.display1}}><center>{c.status}</center></th>
                          </tr>
                        )
                      }
                      else {
                        return (
                          <tr>
                            <th><center>{i}</center></th>
                            <th><center>{c.detailid}</center></th>
                            <th><center>{c.partno+'->'+c.spare_name}</center></th>
                            <th><center>{c.brand_id}</center></th>
                            <th><center>{c.stock}</center></th>
                            <th style={{display: this.props.display}}>
                              <center>
                                { adjstock == 0 ? 
                                  (
                                    <Dropdown id="Control" onChange={this.status(c.detailid, c.stock, c.partno, c.brand_id, c.toBranchId, c.mid, c.mrp)}
                                      search selection options={menu}
                                      value={c.status} fluid
                                      style={{ borderColor: '#5A9CBB', fontSize: 12 }} />
                                  ):
                                  (
                                    <div style={{color: 'red'}}>This Stock in audit</div>
                                  )
                                }
                              
                              </center>
                            </th>
                            <th style={{display: this.props.display1}}><center>{c.status}</center></th>
                          </tr>
                        )
                      }
                    })
                  }
                </table>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.downloadpdf.bind(this)}>PDF DOWNLOAD</Button>
            </DialogActions>
          </Dialog>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth1}  open={this.state.opencustomedialog}
            onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Custom Qty</DialogTitle>
            <DialogContent>
              <DialogContentText>
                  Qty<br/>
                  <Input type='number' value={this.state.qty} onChange={this.onChnageQty('qty')} />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.customQty.bind(this)}>Submit</Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

RequestInItems.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RequestInItems);
